import { useIntl } from 'react-intl'
import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import { AccountStatusesTable } from "./AccountStatusesTable";
import { RootState } from '../../../setup';
import { shallowEqual, useSelector } from 'react-redux'
import { MenuComponent } from '../../../_metronic/assets/ts/components'
import { UserModel } from '../auth/models/UserModel'
import { Dropdown } from 'react-bootstrap-v5'
import { apiUrl as host } from '../../../setup/appConfig'
import { authFetch } from '../auth/redux/AuthFetch'
type Props = {
  className: string
}

export interface IStatebba {
  param?: string;
  param1?: string;
  param2?: string;
}
export interface AccountStatuses {
  statusId: string;
  jib: string;
  entityName: string;
  locatioN_ADDRESS: string;
  issuerDocumentId: string;
  statusValue: string;
  validFrom: string;
  validFrom_string: string;
  validTo: string;
  validTo_string: string;
  number: string;
  bankName: string;
  typE_CODE: boolean;
  address: string;
  streetName: string;
  streetNumber: string;

}
class Signature {
  label1: string
  label2: string
  label3: string
  rightIndentLine1: bigint
  rightIndentLine2: bigint
  rightIndentLine3: bigint
  verticalSpacing1: bigint
  verticalSpacing2: bigint
  verticalSpacing3: bigint

  constructor(label1: string, label2: string, label3: string, rightIndentLine1: bigint, rightIndentLine2: bigint, rightIndentLine3: bigint, verticalSpacing1: bigint, verticalSpacing2: bigint, verticalSpacing3: bigint) {
    this.label1 = label1;
    this.label2 = label2;
    this.label3 = label3;
    this.rightIndentLine1 = rightIndentLine1;
    this.rightIndentLine2 = rightIndentLine2;
    this.rightIndentLine3 = rightIndentLine3;
    this.verticalSpacing1 = verticalSpacing1;
    this.verticalSpacing2 = verticalSpacing2;
    this.verticalSpacing3 = verticalSpacing3;
  }
}



const AccountStatusesBba: React.FC<Props> = ({ className }): any => {


  const [signatures, setSignatures] = useState<Signature[]>([]);
  const [selectedItem, setOnSelectedItem] = useState(Object);
  const user: UserModel = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
  const accessToken: any = useSelector<RootState>(({ auth }) => auth.accessToken, shallowEqual)

  const [uniqueEntityId, setUniqueEntitylId] = useState('')
  const [bban, setBban] = useState('');
  const [IssuerDocumentIdValue, setIssuerDocumentId] = useState('')
  const [RequesteeDocumentIdValue, setRequesteeDocumentId] = useState('')
  const [arrayStatuses, fillStatusesArray] = useState<AccountStatuses[]>([])
  const [requsestId, setRequestId] = useState('');
  const footer = [{ bold1: 'Status računa: ', text1: 'A - aktivan, B - blokiran, U - ugašen', bold2: 'Vrsta računa: ', text2: 'R - redovni, G - glavni, O - račun organizacionog odjela, P - posebne namjene, J - za prikupljanje javnih prihoda, D - devizni, K - depozit koji predstavlja kolateral, S - račun poslovnog subjekta koji je u stečaju, F - finansijska konsolidacija' }]
  let footerArticle = footer[0];
  var AccountStatusesArray: AccountStatuses[] = [];
  var pomArray: AccountStatuses[] = [];
  var pomArray1: AccountStatuses[] = [];

  const intl = useIntl();

  const onKeyDownHandler = (e: any) => {
    if (e.keyCode === 13) {
      getAccountStatusesBba();
    }
  };
  const onChangeBan = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setUniqueEntitylId('');
    setBban(event.target.value);

  }

  const onChangeUniqueEntityId = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setUniqueEntitylId(event.target.value);
    setBban('');


  }
  const onChangeIssuerDocumentId = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setIssuerDocumentId(event.target.value);
  }
  const onChangeRequesteeDocumentId = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setRequesteeDocumentId(event.target.value);
  }
  const onSelectItem = (eventKey: any, event: any) => {
    event.preventDefault();
    event.stopPropagation();
    setOnSelectedItem(signatures[parseInt(eventKey)]);
  }

  const [showNoResultMessage, setShowNoResultMessage] = useState('');
  const resetInputField = () => {
    fillStatusesArray([]);
    setUniqueEntitylId('');
    setBban('');
    setIssuerDocumentId('');
    setRequesteeDocumentId('');
  }

  function resetState() {
    fillStatusesArray([]);
    setUniqueEntitylId('');
    setBban('');
    setIssuerDocumentId('');
    setRequesteeDocumentId('');

  }



  function showToastMessage() {

    toast('Nema podataka u bazi...', { position: toast.POSITION.BOTTOM_CENTER, autoClose: 2000, type: 'error' });
  }


  const legalInquiryHost = host;

  function filterArrayStatuses(validFromStringParam: string) {
    pomArray = arrayStatuses.filter(x => x.validFrom_string === validFromStringParam) as AccountStatuses[]

  }
  const getSignatures = () => {

    const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
    const options = {
      method: 'GET',
      withCredentials: true,
      headers: {
        Accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        ClientId: clientId,
        Authorization: accessToken,
      },
    }

    var endpoint = `${host}/Inquiry/Signatures?RetrieveAll=true&`;

    authFetch(
      endpoint,
      options
    )
      .then((res) => {
        return res.json();
      })
      .then(
        (result) => {



          setSignatures(result.resultList);
          setOnSelectedItem(result.resultList[0]);

          return result.resultList;
        },
        (error) => {
          return []
        }

      )

  }

  function getAccountStatusesBba() {
    getSignatures();
    fillStatusesArray([]);

    var spin = document.querySelector("#search-spin");
    var zoom = document.querySelector("#search-zoom");

    if (spin != null && zoom != null) {
      spin.removeAttribute("hidden");
      zoom.setAttribute("hidden", "true");
    }



    if (uniqueEntityId === '') {
      alert('Molimo vas upišite vrijednost za filter pretrage!');
      if (spin != null && zoom != null) {
        spin.setAttribute("hidden", "true");
        zoom.setAttribute("hidden", "true");
      }
    }
    else {

      const clientId: string = process.env.REACT_APP_CLIENT_ID || '6CAC6ED4-EDA2-4A30-BF01-29CD88E52F44'
      const options = {
        method: 'GET',
        withCredentials: true,
        headers: {
          Accept: 'application/json',
          'Access-Control-Allow-Origin': '*',
          ClientId: clientId,
          Authorization: accessToken,
        },
      }

      var endpoint = `${legalInquiryHost}/inquiry/AccountsStatusesBbaById?RetrieveAll=true&`;
      // var endpoint = `${host}/Inquiry/GetAccount?RetrieveAll=true&`;
      if (uniqueEntityId !== '') {
        endpoint = endpoint + 'JIB=' + uniqueEntityId + '&';
      }
      authFetch(
        endpoint,
        options
      )
        .then((res) => {
          return res.json();
        })
        .then(
          (result) => {
            setRequestId(result.requestId);
            if (result.resultList !== null && result.resultList !== undefined) {
              for (var i = 0; i < result.resultList.length; i++) {

                AccountStatusesArray.push(result.resultList[i] as AccountStatuses)


              }

            }

            fillStatusesArray([...AccountStatusesArray])
            if (result.resultList.length === 0) {
              setShowNoResultMessage('0');
              showToastMessage();
            }


            MenuComponent.reinitialization()

            if (spin != null && zoom != null) {
              spin.setAttribute("hidden", "true");
              zoom.removeAttribute("hidden");
            }
          },
          (error) => {
            return []
          }

        )


    }




  }


  const statusesBbaView = () => {


    return <div className={`card ${className}`} >

      <div className='col-xxl-12' style={{ width: "132%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>




        <div className='card-header align-items-center border-0 mt-2' style={{ width: "100%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>
          <div className='input-group'>
            {/*<h3 className='card-title align-items-start flex-column' style={{ padding: "10px 10px 10px 10px" }}> */}
            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1'>
                <h3 className='card-title align-items-start flex-column' style={{ paddingLeft: "1%", paddingTop: "1%", width: "230%" }} >

                  <span className='fw-bolder mb-2 text-dark'>
                    {intl.formatMessage({ id: 'STATUSES.SEARCHSTATUSES' })}
                  </span>

                </h3>
              </div>
            </div>
            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1'>

              </div>
            </div>
            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1'>

              </div>
            </div>
            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1'>

              </div>
            </div>
          </div>




          <div className='input-group'>

            <div className='col-12 col-sm-6 col-lg-3' style={{ paddingBottom: "1%" }}>
              <div className='d-flex align-items-center position-relative my-1'>
                <input
                  value={uniqueEntityId}
                  onChange={onChangeUniqueEntityId}
                  onKeyDown={onKeyDownHandler}
                  type='text'
                  data-kt-customer-table-filter='search'
                  className='form-control form-control-solid ps-3'
                  placeholder={intl.formatMessage({ id: 'LEGALINQUIRY.UNIQUEENTITYID' })}
                  required
                  title="Unijeti ispravan jib za pretragu"
                />
              </div>
            </div>

            <div className='col-12 col-sm-6 col-lg-3' >
              <div className='d-flex align-items-center position-relative my-1' style={{ paddingBottom: "1%" }}>

              </div>
            </div>
            <div className='col-12 col-sm-6 col-lg-3'>
              <div className='d-flex align-items-center position-relative my-1' style={{ paddingBottom: "1%" }}>

              </div>
            </div>
            <div className='col-12 col-sm-6 col-lg-3' >
              <div className='d-flex align-items-center position-relative my-1' style={{ paddingBottom: "1%" }}>

              </div>
            </div>

            <div className='col-6 col-sm-4 col-lg-6' style={{ paddingBottom: "1%" }}>

              <button className='btn btn-secondary my-1' onClick={resetInputField} style={{ backgroundColor: "#cd513d", color: 'white', width: "24%", marginRight: "2%" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path d="M14.5 20.7259C14.6 21.2259 14.2 21.826 13.7 21.926C13.2 22.026 12.6 22.0259 12.1 22.0259C9.5 22.0259 6.9 21.0259 5 19.1259C1.4 15.5259 1.09998 9.72592 4.29998 5.82592L5.70001 7.22595C3.30001 10.3259 3.59999 14.8259 6.39999 17.7259C8.19999 19.5259 10.8 20.426 13.4 19.926C13.9 19.826 14.4 20.2259 14.5 20.7259ZM18.4 16.8259L19.8 18.2259C22.9 14.3259 22.7 8.52593 19 4.92593C16.7 2.62593 13.5 1.62594 10.3 2.12594C9.79998 2.22594 9.4 2.72595 9.5 3.22595C9.6 3.72595 10.1 4.12594 10.6 4.02594C13.1 3.62594 15.7 4.42595 17.6 6.22595C20.5 9.22595 20.7 13.7259 18.4 16.8259Z" fill="currentColor" />
                  <path opacity="0.3" d="M2 3.62592H7C7.6 3.62592 8 4.02592 8 4.62592V9.62589L2 3.62592ZM16 14.4259V19.4259C16 20.0259 16.4 20.4259 17 20.4259H22L16 14.4259Z" fill="currentColor" />
                </svg>
                <span className="pl-5">
                  {intl.formatMessage({ id: 'ACCOUNT.CLEAR' })}{' '}
                </span>
              </button>





              <button
                type='submit'
                className='btn btn-primary my-1'
                onClick={() => getAccountStatusesBba()} style={{ width: "24%" }}>
                <svg id="search-zoom" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="currentColor" />
                  <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="currentColor" />
                </svg>
                <span id="search-spin" hidden className="spinner-border spinner-border-sm align-middle"></span>
                <span className="pl-5">
                  {intl.formatMessage({ id: 'ACCOUNT.SEARCH' })}{' '}
                </span>
              </button>

            </div>
            <ToastContainer />
          </div>





        </div>
      </div>

      {

        //source_array.length > 0
        arrayStatuses.length > 0

          ?
          (

            /* <TablesWidgetInquiry className='col-xxl-12' parentToChild={source_array} />*/
            < AccountStatusesTable className='col-xxl-12' parentToChild={arrayStatuses} IssuerDocumentId={IssuerDocumentIdValue} RequesteeDocumentId={RequesteeDocumentIdValue} selectedItem={selectedItem} footerArticle={footerArticle} host={legalInquiryHost} accessToken={accessToken} requestId={requsestId} userName={user.username} reset={resetState} />

          )
          :
          (showNoResultMessage === '0') ? (
            <div className='card-header border-0 pt-5 custom-results' style={{ width: "132%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>
              <h3 className='card-title align-items-start flex-column'>
                <span className='text-muted mt-1 fw-bold fs-7'>
                  {intl.formatMessage({ id: 'ACCOUNT.NORESULTS' })}
                </span>

              </h3>
            </div>
          ) : (
            <div className='card-header border-0 pt-5 custom-results' style={{ width: "132%", position: "relative", backgroundColor: "#cfe2f3", alignSelf: "center" }}>
              <h3 className='card-title align-items-start flex-column'>
                <span className='text-muted mt-1 fw-bold fs-7'>

                </span>

              </h3>
            </div>
          )

      }

      {
        (arrayStatuses.length > 0) ?

          (


            <div className='col-xxl-12' style={{ width: "132%", position: "relative", backgroundColor: "#e6e6e6", alignSelf: "center" }} >
              <div className='card-header align-items-center border-0 mt-4' >
                <h3 className='card-title align-items-start flex-column'>
                  <span className='fw-bolder mb-2 text-dark'>
                    IZVOD IZ JEDINSTVENOG REGISTRA RAČUNA POSLOVNIH SUBJEKATA FEDERACIJE BiH
                  </span>
                </h3>
                <div className='row' style={{ width: "132%" }}>


                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M18 22C19.7 22 21 20.7 21 19C21 18.5 20.9 18.1 20.7 17.7L15.3 6.30005C15.1 5.90005 15 5.5 15 5C15 3.3 16.3 2 18 2H6C4.3 2 3 3.3 3 5C3 5.5 3.1 5.90005 3.3 6.30005L8.7 17.7C8.9 18.1 9 18.5 9 19C9 20.7 7.7 22 6 22H18Z" fill="currentColor" />
                            <path d="M18 2C19.7 2 21 3.3 21 5H9C9 3.3 7.7 2 6 2H18Z" fill="currentColor" />
                            <path d="M9 19C9 20.7 7.7 22 6 22C4.3 22 3 20.7 3 19H9Z" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={IssuerDocumentIdValue}
                        onChange={onChangeIssuerDocumentId}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15 kore'
                        placeholder='Broj protokola'
                        required
                      />
                    </div>
                  </div>

                  {/*  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>
                      <span className='svg-icon svg-icon-1 position-absolute ms-6'>
                        <span className='svg-icon svg-icon-1'>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                            <path opacity="0.3" d="M18 22C19.7 22 21 20.7 21 19C21 18.5 20.9 18.1 20.7 17.7L15.3 6.30005C15.1 5.90005 15 5.5 15 5C15 3.3 16.3 2 18 2H6C4.3 2 3 3.3 3 5C3 5.5 3.1 5.90005 3.3 6.30005L8.7 17.7C8.9 18.1 9 18.5 9 19C9 20.7 7.7 22 6 22H18Z" fill="currentColor" />
                            <path d="M18 2C19.7 2 21 3.3 21 5H9C9 3.3 7.7 2 6 2H18Z" fill="currentColor" />
                            <path d="M9 19C9 20.7 7.7 22 6 22C4.3 22 3 20.7 3 19H9Z" fill="currentColor" />
                          </svg>
                        </span>
                      </span>
                      <input
                        value={RequesteeDocumentIdValue}
                        onChange={onChangeRequesteeDocumentId}
                        type='text'
                        data-kt-customer-table-filter='search'
                        className='form-control form-control-solid ps-15'
                        placeholder='Broj zahtjeva'
                        required
                      />
                    </div>
          </div>*/}




                  <div className='col-6 col-sm-3 col-lg-6'>
                    <div className='d-flex align-items-center position-relative my-1'>

                      <Dropdown onSelect={onSelectItem} style={{ width: '100%', color: 'black' }} defaultValue={signatures[0].label3}>
                        <Dropdown.Toggle variant="warning" id="dropdown-custom-2" style={{ width: '100%', color: 'black' }}>
                          {selectedItem.label3}
                        </Dropdown.Toggle>

                        <Dropdown.Menu variant='dark'>
                          <Dropdown.Item eventKey='0' href="#/action-1">{signatures[0].label3}</Dropdown.Item>
                          <Dropdown.Item eventKey='1' href="#/action-2">{signatures[1].label3}</Dropdown.Item>

                        </Dropdown.Menu>

                      </Dropdown>


                    </div>
                  </div>

                </div>

              </div>
            </div>

          ) : null
      }


    </div >


  }

  return statusesBbaView();


}





export { AccountStatusesBba }


